import { browserTracingIntegration, init } from '@sentry/vue';
import type { Plugin } from 'vue';

import { getDomain } from '@libs/utils';

import router from '../router/routerSetup';

const HIGH_SAMPLER_RATE = 0.1;
const DEFAULT_SAMPLER_RATE = 0.01;

export function createLogger(): Plugin {
  return {
    install(app): void {
      if (getDomain.isProduction) {
        init({
          app,
          dsn: 'https://a325fb177cba4b8394fd1302d9a33c15@o4505316832051200.ingest.sentry.io/4505403376599040',
          enabled: getDomain.isProduction,
          ignoreErrors: [
            'ResizeObserver loop completed with undelivered notifications',
            'ResizeObserver loop limit exceeded',
            'Product card image failed loading from',
            'Network Error',
            'Request failed with status code 404',
            '_AutofillCallbackHandler', // NOTE: Common error in Meta built-in browser for iOS that does not affect user experience: https://developers.facebook.com/community/threads/320013549791141/
            'Endpoint: /d/mvc/Members/GetMember',
          ],
          integrations: [
            browserTracingIntegration({
              router,
            }),
          ],
          tracesSampleRate: DEFAULT_SAMPLER_RATE,
          sampleRate: 1,
          tracesSampler: ({ attributes }) =>
            attributes?.['sentry.op'] !== 'pageload'
              ? HIGH_SAMPLER_RATE
              : DEFAULT_SAMPLER_RATE,
        });
      }
    },
  };
}
